export const REFERRAL_BASE_REWARD_CREDITS = 6000;
